module.exports = __webpack_public_path__ + "img/twitterIcon.d6f3df1c.svg";